export default {
      id: "status_offline-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "img/icons.svg#status_offline",
      toString: function () {
        return this.url;
      }
    }